import type { CamelCasedPropertiesDeep } from "type-fest";
import { recursiveCamelCaseCipherTypesafe } from "../../postgrestApi/common";
import FetchClients, { ClientOutput } from "../client";
import { throwBackpackResponseError } from "../errors";

export const ACCOUNT_STATS_KEY = "account-stats";

export type AccountStats = CamelCasedPropertiesDeep<
  ClientOutput["accounts"]["AccountStats"]
> & {
  completedStepsPercent: number;
  completedSitesPercent: number;
};

const stats = {
  getAccountStats,
} as const;

export default stats;

/** Portfolio-wide onboarding totals, with completion percentages derived here. */
export async function getAccountStats(accountId: number) {
  const { data, error } = await FetchClients.accounts.GET(
    "/{account_id}/stats",
    { params: { path: { account_id: accountId } } }
  );
  if (data) {
    const accountStats = recursiveCamelCaseCipherTypesafe(data);
    return {
      ...accountStats,
      // `|| 0` sits inside Math.round to catch the NaN an account with no sites produces
      completedStepsPercent: Math.round(
        (100 * accountStats.completedSteps) / accountStats.totalSteps || 0
      ),
      completedSitesPercent: Math.round(
        (100 * accountStats.completedSites) / accountStats.totalSites || 0
      ),
    };
  }
  throwBackpackResponseError(error);
}
